import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService, LoginData } from '../../services/auth';
import { useTranslation } from 'react-i18next';

const Login: React.FC = () => {
  const [formData, setFormData] = useState<LoginData>({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await authService.login(formData);
      const user = authService.getCurrentUser();
      
      // Redirect based on user role
      if (user?.role === 'resident') {
        navigate('/resident');
      } else if (['manager', 'building_committee'].includes(user?.role || '')) {
        navigate('/manager');
      } else if (['admin', 'central_committee'].includes(user?.role || '')) {
        navigate('/admin');
      } else {
        navigate('/');
      }
    } catch (error: any) {
      setError(error.response?.data?.error || t('auth.login.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>{t('auth.login.title')}</h2>
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">{t('auth.login.email')}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">{t('auth.login.password')}</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? t('auth.login.submitting') : t('auth.login.submit')}
          </button>
        </form>
        
        <p className="auth-link">
          {t('auth.login.noAccount')} <Link to="/register">{t('auth.login.registerLink')}</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
